
import BaseModel from "../../../../core/components/input-widget/BaseModel";
import i18n from "../../../../shared/i18n";

export default class CustomerReservationModel extends BaseModel {
  amount = '';
  auction_uuid = '';

  constructor(data = {}) {
    super();
    Object.assign(this, {...data});
  }

  rules = {
    amount: 'required',
    auction_uuid: 'required',
  };

  attributeLabels = {
    amount: i18n.t('Amount'),
    currency_uuid: i18n.t('Currency'),
    auction_uuid: i18n.t('Sale'),
  };
}
